<template>
  <div
    v-click-outside="closeMenu"
    :class="{ open: data.showMenu === true, shadow: true }"
    class="menuOpen"
    id="nav"
    v-haptic
  >
    <button
      type="button"
      class="menu-toggle"
      :class="{ open: data.showMenu === true }"
      :aria-label="
        data.showMenu ? $t('menu.closeMenu') : $t('menu.openMenu')
      "
      :aria-expanded="data.showMenu"
      aria-controls="menulist"
      @click.stop="toggle"
    >
      <svg class="small menu-toggle__icon" aria-hidden="true" focusable="false">
        <use
          class="menu-toggle__glyph menu-toggle__menu"
          href="@/assets/icons/iconset.svg#menu"
        ></use>
        <use
          class="menu-toggle__glyph menu-toggle__cross"
          href="@/assets/icons/iconset.svg#cross"
        ></use>
      </svg>
    </button>

    <div v-if="data.showMenu" id="menulist">
      <!-- Version badge inside menu -->
      <div class="menu-version-indicator">Unit v{{ appVersion }}</div>

      <span v-if="data.showMenu" class="menulistspan">
        <div class="menu-item menu-link" @click="copyToClipboard">
          <div class="row alignCentreRow">
            <svg class="icon compactImg">
              <use href="@/assets/icons/iconset.svg#link-compact"></use>
            </svg>
            Copy URL
          </div>
        </div>
        <!-- display this when user is logged in -->
        <span v-if="user.loggedIn" class="menuItems" id="loggedInMenuItems">
          <!--   <div v-haptic class="menu-item menu-link" @click="toggleMessages">
            <div class="row alignCentreRow">
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#message_compact"></use>
              </svg>
              Messages
            </div>
          </div>
          <router-link
            v-haptic
            class="menu-item menu-link"
            to="/ecosystem"
            @click.native="resetActiveState('ecosystem'), closeMenu()"
          >
            <div
              class="row alignCentreRow"
              :class="{ active: activeTab === 'ecosystem' }"
              @click="changeTab('ecosystem')"
            >
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#shop-compact"></use>
              </svg>
              Marketplace
            </div>
          </router-link>

          <router-link
            v-haptic
            class="menu-item menu-link"
            to="/wallet"
            @click.native="resetActiveState('wallet'), closeMenu()"
          >
            <div
              class="row alignCentreRow"
              :class="{ active: activeTab === 'wallet' }"
              @click="changeTab('wallet')"
            >
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#wallet-compact"></use>
              </svg>
              Wallet
            </div>
          </router-link> -->

          <!-- <router-link
            v-haptic
            class="menu-item menu-link"
            to="/invites"
            @click.native="resetActiveState('invites'), closeMenu()"
          >
            <div class="row alignCentreRow">
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#invite-compact"></use>
              </svg>
              Invites
            </div>
          </router-link> -->

          <router-link
            v-haptic
            class="menu-item menu-link"
            :to="{ name: 'dashboard', params: { section: 'overview' } }"
            @click="closeMenu"
          >
            <div class="row alignCentreRow">
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#dashboard-compact"></use>
              </svg>
              Admin dashboard
            </div>
          </router-link>

          <!-- Super Admin link moved to bottom -->

          <router-link
            v-haptic
            class="menu-item menu-link"
            :to="{ name: 'account' }"
            @click="closeMenu"
          >
            <div class="row alignCentreRow">
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#user_compact"></use>
              </svg>
              Your settings
            </div>
          </router-link>

          <InlineActionFeedback
            v-haptic
            class="menu-item menu-link"
            :action="confirmSignOut"
            :aria-label="$t('menu.signOut')"
            :confirmation-message="$t('AlertModalLocal.messageLineOne')"
            :confirm-aria-label="$t('buttons.yesLogMeOut')"
          >
            <div class="row alignCentreRow">
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#signOut-compact"></use>
              </svg>
              Sign out
            </div>
          </InlineActionFeedback>
          <router-link
            v-if="currentUserIsSuperAdmin"
            v-haptic
            class="menu-item menu-link"
            :to="{ name: 'super-admin' }"
            @click="closeMenu"
          >
            <div
              class="row alignCentreRow"
              :class="{ active: activeTab === 'superAdmin' }"
            >
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#chart"></use>
              </svg>
              Super Admin
            </div>
          </router-link>
        </span>
        <span v-if="!user.loggedIn" class="menuItems" id="loggedOutMenuItems">
          <div
            class="menu-item menu-link"
            @click="toggleLoginModal"
            :class="isSignInActive"
          >
            <div class="row alignCentreRow">
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#signIn-compact"></use>
              </svg>
              Sign in
            </div>
          </div>
          <router-link
            v-haptic
            class="menu-item menu-link"
            :to="{ name: 'about' }"
            @click="closeMenu"
          >
            <div class="row alignCentreRow">
              <svg class="icon compactImg">
                <use href="@/assets/icons/iconset.svg#owl-compact"></use>
              </svg>
              {{ $t("menu.about") }}
            </div>
          </router-link>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { reactive, computed, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import InlineActionFeedback from "@/components/GenericComponents/InlineActionFeedback.vue";
import {
  currentUserIsSuperAdmin as checkCurrentUserIsSuperAdmin,
} from "@/services/superAdminAccess";
import { toast } from "vue3-toastify";

export default {
  name: "Menu",
  components: {
    InlineActionFeedback,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore(); // Use the store
    // App version from webpack DefinePlugin
    const appVersion = __APP_VERSION__;

    // Use a reactive object to track whether each div is currently active.
    const divIsActive = reactive({
      signIn: false,
    });
    // Toggle the active state of the sign in div.
    const toggleSignInActive = () => {
      divIsActive.signIn = !divIsActive.signIn;
    };
    // Reset the active state of the sign in/out divs.
    const copyToClipboard = () => {
      const url = window.location.href;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(url)
          .then(() => {
            toast.success("URL copied to clipboard", {
              autoClose: 2000,
            });
          })
          .catch((err) => {
            console.error("Failed to copy: ", err);
            toast.error("Cannot copy to clipboard", {
              autoClose: 2000,
            });
          });
      } else {
        // Fallback for unsupported browsers
        const textArea = document.createElement("textarea");
        textArea.value = url;
        textArea.style.position = "fixed"; // Fixed positioning
        textArea.style.top = "0"; // Position it at the top
        textArea.style.left = "-9999px"; // Move it off-screen
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand("copy");
          toast.success("URL copied to clipboard", {
            autoClose: 2000,
          });
        } catch (err) {
          console.error("Fallback: Oops, unable to copy", err);
          toast.error("Cannot copy to clipboard", {
            autoClose: 2000,
          });
        }
        document.body.removeChild(textArea);
      }
      closeMenu();
    };

    // Change the classes assigned based on the active state.
    const isSignInActive = computed(() => {
      return {
        "mimic-active-link": divIsActive.signIn && !showLoginModal.value,
      };
    });
    let data = reactive({
      publicPath: process.env.BASE_URL,
      get showMenu() {
        return store.state.menuOpen;
      },
      set showMenu(value) {
        store.commit("SET_MENU_OPEN", value);
      },
    });

    const areMessagesOpen = computed(
      () => store.getters["UIState/areMessagesOpen"]
    );
    const toggleMessages = () => {
      store.dispatch("UIState/setMessagesMinimised", false);
      store.dispatch("UIState/setMessagesOpen", !areMessagesOpen.value);
      closeMenu();
    };

    const closeMenu = () => {
      data.showMenu = false;
    };

    const toggle = () => {
      data.showMenu = !data.showMenu;
      store.commit("SET_MENU_OPEN", data.showMenu); // Update the Vuex state
      store.dispatch("UIState/setMessagesOpen", false);
    };

    const user = computed(() => store.getters.user);
    const currentUserIsSuperAdmin = ref(false);
    let superAdminRequestId = 0;

    const resolveSuperAdmin = async () => {
      const requestId = ++superAdminRequestId;
      const expectedUid = user.value?.data?.uid;

      // Clear stale access immediately during logout and account transitions.
      currentUserIsSuperAdmin.value = false;
      if (!user.value?.loggedIn || !expectedUid) return;

      const hasAccess = await checkCurrentUserIsSuperAdmin();
      if (
        requestId !== superAdminRequestId ||
        !user.value?.loggedIn ||
        user.value.data?.uid !== expectedUid
      ) {
        return;
      }

      currentUserIsSuperAdmin.value = hasAccess;
    };
    watch(
      () => [user.value?.loggedIn, user.value?.data?.uid],
      resolveSuperAdmin,
      { immediate: true },
    );
    const activeTab = computed(() => route.meta.activeTab || null);
    const showLoginModal = computed(() => store.state.showLoginModal);

    const toggleLoginModal = async () => {
      data.showMenu = false; // Close the menu

      store.dispatch("toggleLoginModal", !showLoginModal.value);
    };

    const confirmSignOut = async () => {
      await store.commit("SET_MENU_OPEN", false);
      setMonetaryParameters();

      await store.dispatch("logOutStateCommit"); // Log out
      await store.dispatch("clearAllState");
      router.push("/"); // Redirect to home route
    };

    const setMonetaryParameters = () => {
      const payload = {
        coinName: "Unit",
        coinSymbol: "Ʉ",
      };
      // for coin symbol component
      store.dispatch("updateCoinSymbol", {
        symbol: "Ʉ",
        name: "Unit",
      });
      // for Monetary rules
      store.commit("SET_MONETARY_PARAMS", payload);
    };

    watch(user, (newValue, oldValue) => {
      // if user was logged in but not anymore, so close the menu if menu was open
      if (oldValue.loggedIn && !newValue.loggedIn) {
        closeMenu();
      }
    });

    return {
      data,
      toggle,
      toggleLoginModal,
      user,
      closeMenu,
      showLoginModal,
      confirmSignOut,
      isSignInActive,
      toggleSignInActive,
      toggleMessages,
      areMessagesOpen,
      activeTab,
      copyToClipboard,
      currentUserIsSuperAdmin,
      appVersion,
    };
  },
};
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}
.no-scroll {
  overflow: hidden;
}

#nav {
  position: -webkit-sticky;
  position: fixed;
  top: 0;
  right: 0;
  padding: var(--space-4) var(--space-5) 0 0;
  display: inline-flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-end;
  box-sizing: border-box;
  z-index: 1;
  transition: width 0.15s ease, max-width 0.15s ease,
    background-color 0.15s ease, box-shadow 0.15s ease,
    border-color 0.15s ease;
  box-shadow: none;
  width: 0%;
}
#nav.open {
  background: var(--color-surface-canvas);
  /* Blur removed */
  box-shadow: 0 2px 6px var(--color-shadow-default);
  border-bottom: 1px solid var(--color-border-muted);
  border-bottom-left-radius: var(--radius-sm);
  height: initial;
  width: fit-content;
  max-width: 64vw;
  z-index: 3;
}

.menuOpen {
  background-color: var(--color-surface-canvas);
  box-shadow: 0 2px 6px var(--color-shadow-default);
}

.aButton {
  margin-left: auto;
  align-self: center;
  background: rgba(255, 255, 255, 0.4);
  /* Blur removed */
  color: var(--color-text-primary);
  border: 1px solid var(--color-text-primary);
  text-decoration: none;
  z-index: 3;
  box-sizing: border-box;
  font-family: var(--font-family-ui);
  font-weight: var(--font-weight-normal);
  transition: background-color 0.15s ease;
}

#menulist {
  padding-top: calc(var(--control-height-default) + var(--space-4));
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  transform: translateX(var(--space-4));
}
.menulistspan {
  width: 100%;
  margin-bottom: var(--space-4);
}

.menuItems {
  width: 100%;
}

#loggedInMenuItems,
#loggedOutMenuItems {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  align-content: flex-end;
}

.menu-item {
  padding: 0 var(--space-4);
  width: 100%;
  height: var(--control-height-default);
  text-decoration: none;
  color: var(--color-text-primary);
  transition: opacity 0.15s, transform 0.15s;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  align-content: flex-end;
  justify-content: center;

  border-radius: var(--radius-sm);
}
.menu-item:hover {
  opacity: 0.8;
  transform: translateY(var(--motion-pressed-offset));
  text-decoration: none;
  color: var(--color-text-primary);
}

.menu-link {
  width: 100%;
  text-align: right;
  margin-top: 5px;
  position: relative;
  cursor: pointer;
}

.menu-link a {
  color: var(--color-text-primary);
  text-decoration: none; /* Remove underline */
}

.menu-link.router-link-active {
  box-shadow: var(--shadow-surface-recessed-compact);
  transform: translateY(1px);
}
.menu-link.router-link-active:before {
  box-shadow: var (--shadow-surface-recessed-compact);
  transform: translateY(1px);
  box-shadow: none;
}

.menu-link.router-link-active + *::before {
  /* To hide the ::before pseudo-element from the immediate sibling after the .router-link-active */
  display: none;
}

.no-active-style.router-link-active {
  box-shadow: none;
  transform: none;
}

.no-active-style.router-link-active::before {
  box-shadow: var(--shadow-surface-recessed-compact);
}

.menu-link::before {
  content: "";
  position: absolute;
  top: -5px;
  left: 0;
  width: 100%;
  height: 5px;
  box-shadow: var(--shadow-divider-recessed);
  filter: none;
}

.menu-item-enter-from,
.menu-item-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

/* mimic buttons for divs that don't route in the menu */
.mimic-active-link {
  box-shadow: var(--shadow-surface-recessed-compact);
  transform: translateY(1px);
}

/* Animated menu/cross icon. The 46px button preserves the touch target while
   the SVG matches the 24px icons used by the rest of the navbar. */
.menu-toggle {
  position: absolute;
  top: var(--space-4);
  right: var(--space-5);
  display: grid;
  place-items: center;
  width: var(--control-height-default);
  height: var(--control-height-default);
  padding: 0;
  color: var(--color-icon-primary);
  background: transparent;
  border: 0;
  z-index: 2;
  transition: none;
  cursor: pointer;
}

.menu-toggle:hover {
  transform: none;
}

svg.menu-toggle__icon {
  width: var(--control-height-dense);
  height: var(--control-height-dense);
}

.menu-toggle__glyph {
  transform-box: fill-box;
  transform-origin: center;
  transition:
    opacity var(--motion-standard) var(--motion-easing-standard),
    transform var(--motion-standard) var(--motion-easing-standard);
}

.menu-toggle__menu {
  opacity: 1;
  transform: rotate(0deg) scale(1);
}

.menu-toggle__cross {
  opacity: 0;
  transform: rotate(-90deg) scale(0.72);
}

.menu-toggle.open .menu-toggle__menu {
  opacity: 0;
  transform: rotate(90deg) scale(0.72);
}

.menu-toggle.open .menu-toggle__cross {
  opacity: 1;
  transform: rotate(0deg) scale(1);
}

/* Version badge styles */
.menu-version-indicator {
  position: absolute;
  top: calc(var(--space-4) * 0.75);
  left: calc(var(--space-4) * 0.75);
  font-size: var(--font-size-micro);
  color: var(--color-text-muted);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  pointer-events: none;
  opacity: 0.6;
  z-index: 10;
}

.menu-version-bottom {
  position: relative;
  top: auto;
  right: auto;
  text-align: right;
  padding: var(--space-4);
  margin-top: var(--space-4);
  opacity: 0.5;
}

/* SMALL SCREENS */

/* SMALL SCREENS */
@media only screen and (max-width: 490px) {
}

@media only screen and (max-width: 900px) {
  #nav a.logo {
    display: inline-flex;
    width: calc(100vw - 60px);
    height: 60px;
    justify-content: center;
    padding: 0 0 1.5rem 0 !important;
  }
}
</style>
